// extracted by mini-css-extract-plugin
export default {"sub-title":"subTitle_sub-title__830FA"};